import { parseCustomerListSearchQuery } from './customerSearchFilter';

/**
 * Converte busca unificada (nome vs CPF) em parâmetros da listagem PF.
 * @param {string} searchQuery
 * @returns {{ name?: string, cpf?: string }}
 */
export function buildPhysicalPersonListFilters(searchQuery) {
    const { name, document } = parseCustomerListSearchQuery(searchQuery);
    const filters = {};
    if (name) filters.name = name;
    if (document) filters.cpf = document;
    return filters;
}
